var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_7088)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.426904 9.88041C0.426436 11.5608 0.868936 13.2016 1.71034 14.6478L0.346436 19.589L5.44269 18.2631C6.85224 19.0245 8.43155 19.4235 10.0364 19.4236H10.0407C15.3387 19.4236 19.6514 15.1458 19.6537 9.88793C19.6547 7.3401 18.6557 4.94428 16.8405 3.1418C15.0257 1.33948 12.612 0.346378 10.0403 0.345215C4.74159 0.345215 0.42917 4.62273 0.426982 9.88041",
    fill: "url(#paint0_linear_11_7088)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0835938 9.87721C0.0830469 11.6181 0.541406 13.3175 1.41281 14.8155L0 19.9339L5.27898 18.5605C6.73352 19.3474 8.37117 19.7622 10.0376 19.7629H10.0419C15.53 19.7629 19.9977 15.3312 20 9.88512C20.0009 7.24574 18.9659 4.7638 17.0859 2.89674C15.2057 1.02992 12.7057 0.00108527 10.0419 0C4.55281 0 0.0857813 4.43101 0.0835938 9.87721ZM3.22734 14.5575L3.03023 14.2471C2.20164 12.9398 1.7643 11.4291 1.76492 9.87783C1.76672 5.35109 5.47953 1.66822 10.045 1.66822C12.2559 1.66915 14.3337 2.52434 15.8966 4.07597C17.4593 5.62775 18.3192 7.69054 18.3187 9.8845C18.3166 14.4112 14.6037 18.0946 10.0419 18.0946H10.0386C8.5532 18.0938 7.09641 17.698 5.82594 16.95L5.52359 16.7721L2.39094 17.5871L3.22734 14.5574V14.5575Z",
    fill: "url(#paint1_linear_11_7088)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.55303 5.74801C7.36662 5.33692 7.17045 5.32863 6.99318 5.32142C6.84803 5.31522 6.68209 5.31568 6.51631 5.31568C6.35037 5.31568 6.08076 5.37762 5.85287 5.62452C5.62475 5.87165 4.98193 6.46886 4.98193 7.68351C4.98193 8.89824 5.87357 10.0721 5.99787 10.237C6.12232 10.4016 7.7192 12.974 10.2483 13.9636C12.3501 14.786 12.7779 14.6224 13.234 14.5812C13.6903 14.5401 14.7062 13.9841 14.9135 13.4076C15.1209 12.8312 15.1209 12.3371 15.0587 12.2338C14.9965 12.131 14.8306 12.0692 14.5818 11.9458C14.3329 11.8223 13.1096 11.225 12.8815 11.1426C12.6534 11.0603 12.4876 11.0192 12.3216 11.2664C12.1557 11.5132 11.6792 12.0692 11.534 12.2338C11.3889 12.3989 11.2437 12.4194 10.9949 12.2959C10.7459 12.172 9.94459 11.9116 8.99389 11.0706C8.2542 10.4162 7.75482 9.60808 7.60967 9.36088C7.46451 9.11405 7.59412 8.98026 7.71889 8.85723C7.83068 8.74661 7.96779 8.56894 8.09232 8.42483C8.21639 8.28064 8.25779 8.17777 8.34076 8.01312C8.42381 7.84832 8.38225 7.70413 8.32014 7.58064C8.25779 7.45715 7.77428 6.23615 7.55303 5.74801Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11_7088",
    x1: 965.71,
    y1: 1924.73,
    x2: 965.71,
    y2: 0.345215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11_7088",
    x1: 1000,
    y1: 1993.39,
    x2: 1000,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_7088"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.a69bc09d4e5853a8a6eee804acf0731d.svg";
export { ForwardRef as ReactComponent };